import { toTimestamp, toGeoPoint } from './firemapper'
import { DefaultAddress, DefaultTask } from './task'


export const Mapper = (form) => {
      
    const mapAddress = {
        address1: (form.address && form.address.address1) || null,
        address2: (form.address && form.address.address2) || null,
        postalCode: (form.address && form.address.postalCode) || null,
        city: (form.address && form.address.city) || null,
        state: null,
        country: (form.address && form.address.country) || null
      }

    const mapped = {
        createdAt: form.createdAt ? toTimestamp(form.createdAt) : null,
        createdBy: form.createdBy || null,
        projectId: form.projectId || null,
        agentId: form.agentId || null,
        title: form.title || null,
        summary: form.summary || null,
        description: form.description || null,
        state: form.state || null,
        expire: form.expire ? toTimestamp(form.expire) : null,
        subtasks: form.subtasks ? form.subtasks : null,
        geolocation: form.geolocation ? toGeoPoint(form.geolocation) : null,
        address: mapAddress
    }
    return mapped
  }

  export const NewTask = () => {
    let address = {...DefaultAddress}
    let task = {...DefaultTask, address, subtasks: []}
    return task
  }
